import { useLocation } from "react-router-dom";
import { useLoggedInAs } from "./useLoggedInAs";
import { EnumOwnerType } from "gql/generated";

export const useCurrentAppRoute = () => {
  const location = useLocation();
  const loggedInAs = useLoggedInAs();

  // NOTE : parts[0] is always "" because the routes always
  // start with "/", so the left of that is an empty string
  const parts = location.pathname.split("/");
  if (parts.length < 3) {
    // Invalid app path, so return the application route
    return {
      root: "/app",
      appPath: "",
    };
  }

  const root =
    loggedInAs?.type === EnumOwnerType.Operator
      ? parts.slice(0, 3).join("/")
      : parts.slice(0, 4).join("/");

  const appPath =
    loggedInAs?.type === EnumOwnerType.Operator && parts.length > 3
      ? // Operator routes start with "/app/operator"
        // parts[3] would be "/:operatorId"
        // TODO : When Calendar/Events, Booker, etc. are added figure our how to handle them
        parts[3]
      : // Organization routes start with "/app/organization/:organizationId"
        // parts[4] would be "home", "directory", "custom-lists", "widgets", "profile", etc.
        parts.length > 4
        ? parts[4]
        : "";

  return { root, appPath };
};
